import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getReplenishmentBaseProductDetail(baseProductId) {
  return fetchQuery("GetReplenishmentBaseProductDetail", { baseProductId: baseProductId });
}
